// eslint-disable-next-line import/prefer-default-export
export const indexReducedPattern = 'index-reduced-royalty-calculation-*';
